import React from 'react';

import { WithQuerystringFiltering, WithInMemoryFiltering } from '../../../shared/hocs';

import { InnerEnhancedFilterableProductList } from './components';
import { EnhancedFilterableProductListProps } from './enhanced-filterable-product-list-type';

const enhancedQueryStringFilterableProductList: React.FC<EnhancedFilterableProductListProps> = React.memo(
    (props: EnhancedFilterableProductListProps) => {
        return <InnerEnhancedFilterableProductList {...props} />;
    },
);

export const EnhancedQuerystringFilterableProductList = WithQuerystringFiltering()(
    enhancedQueryStringFilterableProductList,
);

export const EnhancedInMemoryFilterableProductList = WithInMemoryFiltering()(enhancedQueryStringFilterableProductList);
